import { Form } from "@/components/ui/form";
import { useTemplateWithFields } from "@/hooks/useTemplateWithFields";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";

interface TemplateFormWrapperProps {
  onSubmit: (data: { name: string }) => Promise<void>;
  isSubmitting: boolean;
  templateId?: string;
  children: React.ReactNode;
}

export const TemplateFormWrapper = ({ onSubmit, isSubmitting, templateId, children }: TemplateFormWrapperProps) => {
  const _navigate = useNavigate();
  const { template } = useTemplateWithFields();

  const form = useForm({
    defaultValues: {
      name: "",
    },
  });

  useEffect(() => {
    if (template) {
      form.reset({
        name: template.name || "",
      });
    }
  }, [template, form]);

  return (
    <Form {...form}>
      <form
        onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
          const submitEvent = e as unknown as SubmitEvent;
          if (submitEvent.submitter?.getAttribute("type") === "submit") {
            form.handleSubmit(onSubmit)(e);
          } else {
            e.preventDefault();
          }
        }}
        className="space-y-6"
      >
        {children}
      </form>
    </Form>
  );
};
